import React, { Component } from "react";
import { FreshdeskAPIWidget } from "views/Help/component";
import CoverPhotoSwitcher from "./CoverPhotoSwitcher";

class CoverPhotoUploadButton extends Component {
  render() {
    // styles are in the same directory in editor.scss line 17. This butto is being hidden in the index.jsx line 847 so this button will only show in the PMA Editor and not in the Print Version
    const {
      showAllEditButtons,
      currentArea,
      useAlternatePhoto,
      onPhotoChange,
      savingPhotoChoice,
      isAlternateCoverPhotoEnabled,
    } = this.props;
    if (showAllEditButtons) {
      return (
        <div className="cover-photo-buttons">
          <FreshdeskAPIWidget currentArea={currentArea}>
            <div className="cover-photo-upload-button">
              <p>Click here to submit a</p>
              <p>custom cover photo</p>
            </div>
          </FreshdeskAPIWidget>
          {isAlternateCoverPhotoEnabled && (
            <CoverPhotoSwitcher
              useAlternatePhoto={useAlternatePhoto}
              saving={savingPhotoChoice}
              onChange={onPhotoChange}
            />
          )}
        </div>
      );
    }
    return "";
  }
}

export default CoverPhotoUploadButton;
